<template>

    <span class="">
        <template v-if="user.avatar_url">
            <img :src="user.avatar_url" alt="" class="rounded-circle img-fluid avatar" />
        </template>
        <template v-else>
            <i class="bi bi-person-circle avatar-default"></i>
        </template>
    </span>

</template>


<script>
    export default {
        props: [
            'user'
        ],
        data() {
            return {

            }
        }
    }
</script>